<template>
	<md-card>
		<md-card-content class="ask-detail-section ask-text-content">
			<div class="ask-detail">
				<!-- <div class="ask-member-container vtopblock">
				</div> -->
				<div class="inline-grid">
					<div class="ask-member-details">
						<div class="edit-ask" v-if="memberData && memberData.first && memberData.last"> <span class="display-link" @click="goToProfile(memberData._id)">{{ memberData.first + ' ' +  memberData.last }}</span>
							<member-picker v-on:chosen="addSeeker" iconName="Member" editAsk="true" section="addAsk" :community="ask.community._id">Choose advisor...</member-picker>
						</div>
						<div class="edit-ask" v-else-if="memberData"> <span class="display-link" @click="goToProfile(memberData._id)">{{ memberData.displayName }}</span>
							<member-picker v-on:chosen="addSeeker" iconName="Member" editAsk="true">Choose advisor...</member-picker>
						</div>
						<span v-if="memberData && memberData.first && memberData.last">{{memberData.emails[0]}}</span>
					</div>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Channel</p>
					<span>{{ask.channelType}}</span>
				</div>
				<div class="inline-grid">
					<circle-picker :ask="ask"></circle-picker>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Request Received</p>
					<span v-if="ask.reqReceivedDate">{{ask.reqReceivedDate | momentDate}}</span>
					<span v-else>N/A</span>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Advisors Asked</p>
					<span v-if="ask.recommendedAdvisors && ask.recommendedAdvisors.length > 0">{{ask.recommendedAdvisors.length}}</span>
					<span v-else>N/A</span>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Member Role</p>
					<span v-if="memberData && memberData.member_role" class="ask-member-role"><b>{{memberData.member_role}}</b></span>
				</div>
				<!-- <div class="inline-grid">
					<p class="ask-header">Advice Area</p>
					<span v-if="ask.advice_area">{{ ask.advice_area }}</span>
					<span v-else>N/A</span>
				</div> -->
				<div class="inline-grid">
					<p class="ask-header">Request Sent</p>
					<span v-if="ask.reqSentDate">{{ask.reqSentDate | momentDate}}</span>
					<span v-else>N/A</span>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Responses</p>
					<span v-if="positiveResponse > 0">{{positiveResponse}}</span>
					<span v-else>N/A</span>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Advisor Feedback</p>
					<span v-if="advisorFeedback > 0">{{advisorFeedback}}</span>
					<span v-else>N/A</span>
				</div>
				<div class="inline-grid">
					<p class="ask-header">Member Feedback</p>
					<span v-if="memberFeedback > 0">{{memberFeedback}}</span>
					<span v-else>N/A</span>
				</div>
        <div class="inline-grid">
					<p class="ask-header">Last Advisor Match</p>
					<span v-if="ask.matchAdviserDate">{{ask.matchAdviserDate | momentDate}}</span>
					<span v-else>N/A</span>
				</div>
			</div>
		</md-card-content>
	</md-card>
</template>

<!-- Script-->
<script>
import API from "../services/API";
import MemberPicker from "./MemberPicker";
import CirclePicker from "./CirclePicker";
export default {
	name: "AskDetail",
	components: {
		MemberPicker,
		CirclePicker
	},
	props: ["ask", "editAsk", "community", "createdByMember", "feedbacks"],
	data() {
		return {
			api: new API(),
			communityStyle: {
				backgroundColor: "white",
				color: "black"
			},
			memberData: this.ask.createdByMemberID,
			advisorFeedback: 0,
			memberFeedback: 0,
			positiveResponse: 0
		};
	},
	watch: {
		ask: function (newVal, oldVal) {
			this.loadData();
		}
	},
	methods: {
		loadData: async function () {
			var reqTotal = 0;
			var resTotal = 0;
			var reqScore = 0;
			var resScore = 0;
			if (this.ask && this.ask.createdByMemberID) {
				this.memberData = this.ask.createdByMemberID;
			}
			if (this.ask.gives && this.ask.gives.length > 0) {
				var positivecount = 0;
				await this.ask.gives.map(singleGive => {
					if (singleGive.helpaction === 'yes' && singleGive.responseState.currentState === 'Approved') {
						positivecount++;
					}
				});
				this.positiveResponse = positivecount;
			}
			await this.feedbacks.map(singleFeedbacks => {
				if (singleFeedbacks.type === 'Request') {
					reqTotal++;
					reqScore += singleFeedbacks.rating;
				} else if (singleFeedbacks.type === 'Response') {
					resTotal++;
					resScore += singleFeedbacks.rating;
				}
			})
			resScore = parseInt(resScore);
			resTotal = parseInt(resTotal);
			reqTotal = parseInt(reqTotal);
			reqScore = parseInt(reqScore);
			this.memberFeedback = Number(parseFloat(resScore / resTotal).toFixed(2));
			this.advisorFeedback = Number(parseFloat(reqScore / reqTotal).toFixed(2));
			this.circleName = this.ask.sourceparam;
		},
		addSeeker: async function (members) {
			if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
				if (this.editAsk) {
					await this.api
						.put(`asks/${this.ask._id}/edit-member`, {
							member: members[0]
						}).then(response => {
							this.memberData = response.data.member;
						});
				}
				this.ask.createdByMemberID = members[0];
				this.$emit('chosen', members);
			} else {
				// console.log("this.community :", this.ask.community);
				let closeMessage = this.ask.community.content.closeRequestMessage;
				this.$toast.error(closeMessage);
			}
		},
		goToProfile: function (Id) {
			let route = this.$router.resolve({path: `/members/${Id}`});
			window.open(route.href, '_blank');
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/AskDetail.vue